export enum CreateService {
  Artifacts = 'Artifacts',
  CalendarAttachments = 'CalendarAttachments',
  DriveRevisions = 'DriveRevisions',
  MailMessages = 'MailMessages',
  SiteItems = 'SiteItems'
}
